module.exports = __webpack_public_path__ + "media/images/icons/icon-feather-46c61c2fb802cff89a5fad9d0490f866.svg";